import { TextField, Typography, Box, IconButton } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { Plan } from '@weft/types';
import { useSoftUpdatePlan } from 'apps/app/src/hooks/requests/use-update-soft-plan';
import { useActivate } from 'apps/app/src/hooks/use-activate';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React, { useState } from 'react';

type ContractPageTitleProps = {
  plan: Plan;
};

export const ContractPageTitle: React.FC<ContractPageTitleProps> = ({ plan }) => {
  const [isEditing, enterEditMode, exitEditMode] = useActivate(false);
  const [editPlanName, setEditPlanName] = useState(plan.name);
  const [isHovered, setIsHovered] = useState(false);
  
  const softUpdatePlanMutation = useSoftUpdatePlan(plan.id);

  const handlerPlanNameBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
    if (event.target.value === plan.name) {
      return;
    }

    await runMutation(
      softUpdatePlanMutation,
      { name: event.target.value },
      {
        pending: 'Updating contract...',
        success: 'Contract updated',
        error: 'Failed to update contract',
      },
      {
        onSuccess: () => {
          exitEditMode();
          setEditPlanName(event.target.value);
        },
      },
    );
  };

  const handleTitleClick = () => {
    enterEditMode();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEditPlanName(event.target.value);
  };

  return (
    <>

      {isEditing ? (
        <TextField
          value={editPlanName}
          onChange={handleChange}
          onBlur={handlerPlanNameBlur}
          autoFocus
          variant="standard"
          size="small"
          sx={{
            margin: '0',
            '& .MuiInputBase-input': {
              fontFamily: 'OakesGrotesk',
              fontWeight: 400,
              fontSize: '1.25rem',
              lineHeight: 1.334,
              marginTop: '8px',
            },
          }}
        />
      ) : (
        <Box
          display="flex"
          alignItems="center"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Typography
            onClick={handleTitleClick}
            sx={{
              color: 'text.primary',
              cursor: 'pointer',
              fontFamily: 'OakesGrotesk',
              fontWeight: 400,
              fontSize: '1.25rem',
              lineHeight: 1.334,
              marginTop: '8px',
            }}
          >
            {editPlanName}
          </Typography>
         
          {isHovered && (
            <IconButton
              size="small"
              onClick={handleTitleClick}
              sx={{ marginLeft: '10px' }}
            >
              <VyIcon icon="Edit" />
            </IconButton>
          )}
        </Box>
      )}
    </>
  );
};
